/*
 * 头部面包屑
 *
 * @Author: fan.li@zuolin.com
 * @Date: 2019-07-31 21:28:22
 * @Last Modified by: fan.li@zuolin.com
 * @Last Modified time: 2019-08-02 12:05:33
 */

import * as React from 'react';
import PropTypes from 'prop-types';
import { LeftCircleOutlined } from '@ant-design/icons';
import { Breadcrumb } from 'antd';
import { Link, withRouter } from 'react-router-dom';

import './index.less';

const prefixCls = 'eh-header-breadcrumb-nav-component';
const BreadcrumbItem = Breadcrumb.Item;

@withRouter
export default class BreadcrumbNav extends React.PureComponent {
	/**
	 * 根据当前的pathname从配置文件中获取到当前的面包屑配置信息
	 * @memberof BreadcrumbNav
	 */
	getBreadcrumbConfigs = () => {
		const { routes, location } = this.props;
		const pathSnippets = location.pathname.split('/').filter(i => i);
		const arr = [];

		pathSnippets.forEach((_, index) => {
			const url = `/${pathSnippets.slice(0, index + 1).join('/')}`;
			if (routes[url]) {
				arr.push({ url, name: routes[url] });
			}
		});

		return arr;
	}

	/**
	 * 根据当前pathname从目录配置文件中获取到当前路径属于哪个模块,
	 * 目前只考虑2级菜单栏，不考虑递归情况
	 *
	 * @memberof BreadcrumbNav
	 */
	getBreadcrumbFoldModule = (configs) => {
		const { menus } = this.props;

		if (configs && configs.length) {
			const moduleDataType = configs[0].url.substr(1); // 去掉头部的斜杆

			for (let i = 0; i < menus.length; i++) {
				const mod = menus[i];
				const dtos = mod.dtos;

				if (dtos) {
					for (let j = 0; j < dtos.length; j++) {
						const subMod = dtos[j];

						if (subMod.dataType === moduleDataType) {
							return mod;
						}
					}
				}
			}
			return null;
		}
		return null;
	}

	render () {
		const arr = this.getBreadcrumbConfigs();
		const foldModule = this.getBreadcrumbFoldModule(arr);

		return (
            <div className={prefixCls}>
				<span className={`${prefixCls}-icon`}>
				  {arr.length > 1 && (
						<LeftCircleOutlined onClick={() => this.props.history.goBack()} />
					)}
				</span>

				<Breadcrumb separator="/">
				  {!!foldModule && (
						<BreadcrumbItem>
							{foldModule.name}
						</BreadcrumbItem>
					)}

					{arr.map(({ url, name }, index) => {
						if (index === arr.length - 1) {
							return (
								<BreadcrumbItem key={url}>
									{name}
								</BreadcrumbItem>
							);
						}

						return (
							<BreadcrumbItem key={url}>
								<Link to={url}>
									{name}
								</Link>
							</BreadcrumbItem>
						);
					})}
				</Breadcrumb>
			</div>
        );
	}
}

BreadcrumbNav.defaultProps = {
	routes: {},
	menus: [],
};

BreadcrumbNav.propTypes = {
	routes: PropTypes.object, // 路由对应面包屑名称配置
	menus: PropTypes.array,   // 左侧菜单栏配置
};
